<template>
	<div class="page yarn-count-converter">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<svg class="navigation-icon left" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M50 100a50 50 0 1 1 50-50 50.06 50.06 0 0 1-50 50zm0-96a46 46 0 1 0 46 46A46.05 46.05 0 0 0 50 4zm42 48H56v-4h31.95a38 38 0 0 0-75.9 0H44v4H8v-2a42 42 0 0 1 84 0z"/><path d="M50 58a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm21 38H29a2 2 0 0 1-2-2V64a2 2 0 0 1 2-2h42a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2zm-40-4h38V66H31zm19-62a2 2 0 0 1-2-2v-6a2 2 0 0 1 4 0v6a2 2 0 0 1-2 2zM26 28a2 2 0 0 1-1.41-.59l-4.3-4.28a2 2 0 0 1 2.83-2.83l4.24 4.24A2 2 0 0 1 26 28z"/><path d="M74 28a2 2 0 0 1-1.41-3.41l4.24-4.24a2 2 0 0 1 2.83 2.83l-4.24 4.24A2 2 0 0 1 74 28zM56 50a2 2 0 0 1-1.93-1.47L50 33.6l-4.07 14.93a2 2 0 0 1-3.86-1.05l6-22a2 2 0 0 1 3.86 0l6 22A2 2 0 0 1 56 50z"/></svg>
					<span class="navigation-title">{{$t('yarn-count-converter')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<form @submit.prevent="convert" ref="form">
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="number">{{$t('insert-value')}}</label>
									<div class="element">
										<input type="number" placeholder=" " min="0" step="any" v-model="number" id="number">
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="from">{{$t('unit-of-measurement')}}</label>
									<div class="element">
										<select v-model="from" id="from">
											<option
												v-for="(unit, index) in units"
												:key="'unit-'+index"
												:value="unit.code"
											>
												{{$t(unit.name)}}
											</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
				<div class="container">
					<div class="content">
						<YarnCountTable :units.sync="units" :selected="from"/>
					</div>
				</div>
			</section>
		</transition>
	</div>
</template>

<script>
import YarnCountTable from '@/components/YarnCountTable.vue'

export default {
	data() {
		return {
			from: this.$settings.data.defaultYarnCount,
			number: '1',
			units: [...this.$yarnCountUtils.units]
		};
	},
	components: {
		YarnCountTable
	},
	mounted() {
		this.convert();
	},
	watch: {
		from() {
			this.convert();
		},
		number() {
			this.convert();
		}
	},
	methods: {
		convert() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			let self = this;
			this.units.forEach(function(unit, index) {
				unit.value = self.$yarnCountUtils.convert(self.number, self.from, unit.code);
				self.$set(self.units, index, unit);
			});
		}
	}
}
</script>

<style scoped>
	#conversions {
		margin-top: .8rem;
	}
</style>